import { Directive, Input, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[maskedElement]'
})
export class MaskedElementDirective implements OnInit {

  @Input() maskedText: string = 'Not Available';
  @Input() set maskedElement(value: any) {
    this._isMasked = value == 'true'?true:false;
    this.setDisplay();
  }

  @Input() set masked(value:any){
    this._isMasked = value == 'true'?true:false;
    this.setDisplay();
  }
  private _isMasked:boolean = false;

  constructor(private el: ElementRef,private renderer: Renderer2) {

  }

  ngOnInit(): void {

    // create the mask div
    const mask = document.createElement('div');
    const title = document.createElement('h3');
    const titleHolder = document.createElement('div');
    title.innerHTML = this.maskedText;

    titleHolder.appendChild(title);
    mask.appendChild(titleHolder);
    this.renderer.appendChild(this.el.nativeElement, mask);
    this.renderer.addClass(this.el.nativeElement, 'masked-element');
    this.renderer.addClass(mask, 'mask');
    this.renderer.addClass(titleHolder, 'mask-title-holder');

    this.setDisplay();
  }

  private setDisplay():void{
    if(this._isMasked){
      this.renderer.addClass(this.el.nativeElement, 'masked-element-shown');
    }else{
      this.renderer.removeClass(this.el.nativeElement, 'masked-element-shown');
    }
  }

  ngOnDestroy(): void {

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/masked-element.directive.ts